const LANES = [
  ["adversarial", "Adversarial", "bg-[#0A192F] text-white border-[#0A192F]"],
  ["left", "Left", "bg-rose-50 text-rose-800 border-rose-300"],
  ["science", "Science", "bg-sky-50 text-sky-800 border-sky-300"],
  ["other", "Other", "bg-slate-50 text-slate-600 border-slate-300"],
];

export const LaneChips = ({ lanes }) => {
  if (!lanes) return null;
  return (
    <div data-testid="scout-run-lanes" className="mb-2 flex flex-wrap gap-1.5">
      {LANES.map(([k, label, cls]) => (
        <span key={k} data-testid={`scout-run-lane-${k}`} className={`border px-2 py-0.5 text-[10px] uppercase tracking-wider ${cls}`}>
          {lanes[k] ?? 0} {label}
        </span>
      ))}
    </div>
  );
};

export default LaneChips;
